import {
  AppBar,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
} from "@mui/material";
import { useState } from "react";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import LoginIcon from "@mui/icons-material/Login";
import { useNavigate } from "react-router-dom";
import logo from "../assets/Images/SPCLEP.jpg";
import style from "./Header.module.scss";
import Lang from "../Utils/lang";
import MenuIcon from "@mui/icons-material/Menu";
import PropTypes from "prop-types";

const lang = Lang.getInstance();
function Header({ menuButtonClick }) {
  const [anchors, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const username = localStorage.getItem("userName");
  const roles = localStorage.getItem("roles");

  /**
   *
   */
  function logout() {
    localStorage.setItem("userId", "");
    localStorage.setItem("userName", "");
    localStorage.setItem("access_token", "");
    localStorage.setItem("roles", "");
    navigate("/login");
  }
  return (
    <>
      <AppBar position="fixed" className={style.appBar}>
        <Toolbar>
          {roles && roles.includes("admin") ? (
            <IconButton onClick={menuButtonClick}>
              <MenuIcon style={{ color: "white" }} />
            </IconButton>
          ) : (
            ""
          )}
          <img
            src={logo}
            alt="Politia"
            height="47"
            style={{ margin: 5, borderRadius: 10 }}
          />
          <div className={style.container}>
            {username ? (
              <span className={style.usernameText}>
                {lang.get("username")}: {username}
              </span>
            ) : (
              <IconButton
                size="medium"
                color="inherit"
                id="login"
                style={{ color: "white" }}
                onClick={() => navigate("/login")}
              >
                <span className={style.loginText}>{lang.get("login")}</span>
                <LoginIcon />
              </IconButton>
            )}
            <IconButton
              size="medium"
              color="inherit"
              id="options"
              style={{ color: "white" }}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <AccountBoxIcon />
            </IconButton>
            <Menu
              anchorEl={anchors}
              open={Boolean(anchors)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{
                style: {
                  "&hover": {
                    backgroundColor: "white",
                  },
                  padding: 10,
                },
              }}
            >
              {username ? (
                <MenuItem onClick={logout}>
                  <ExitToAppIcon />
                  <span style={{ marginLeft: 10 }}>{lang.get("logout")}</span>
                </MenuItem>
              ) : (
                ""
              )}
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </>
  );
}
export default Header;
Header.propTypes = {
  menuButtonClick: PropTypes.func,
};
